/* ==========================================
    DEFINE CONFIG HERE
   ========================================== */

module.exports = {
  existing_url: 'https://www.frameusa.com',
}
